import React from 'react';
import Button from '~/src/components/Button';
import { DialogContainer } from '~/src/components/Modal/mui/DialogContainer';
import { MessageDialog } from '~/src/components/Modal/mui/MessageDialog';

interface IdentityMigrationCompletedModalContentsProps {
  open: boolean;
  onClose: () => void;
  email: string;
}

const IdentityMigrationCompletedModalContents: React.FC<
  IdentityMigrationCompletedModalContentsProps
> = ({ open, onClose, email }) => {
  return (
    <DialogContainer open={open} onClose={onClose} canCloseWithBgClick={false}>
      <MessageDialog
        title="Clio Login Setup Successful"
        onClose={onClose}
        showCloseButton={true}
        dialogActions={
          <>
            <Button onClick={onClose} primary style={{ fontWeight: 600 }}>
              Got it
            </Button>
          </>
        }
      >
        <div>
          <p>
            You have successfully created or connected your Clio Login with Clio
            Draft for <strong>{email}</strong>. You can now login through{' '}
            <strong>
              <a href="https://clio.com/login" target="_blank" rel="noreferrer">
                clio.com/login
              </a>
            </strong>
            .
          </p>
          <br />
          <p>
            Have questions or need help? Contact our support team at{' '}
            <strong>
              <a href="mailto:support@clio.com">support@clio.com</a>
            </strong>
            .
          </p>
        </div>
      </MessageDialog>
    </DialogContainer>
  );
};

export default IdentityMigrationCompletedModalContents;
